export default __webpack_public_path__ + "51e863b40743ddaf41ad2330736c2ae4.png";